import { Link as RouterLink } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import get from 'lodash/get'
import filter from 'lodash/filter'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import { useTeam } from '../../../../contexts/TeamContext'
import { useServices } from '../../../../contexts/ServicesContext'
import { useProjects } from '../../../../contexts/ProjectsContext'
import { useIngresses } from '../../../../contexts/IngressesContext'
import { useNodeTasks } from '../../../../contexts/NodeTasksContext'
import Flex from '../../../../shared/components/layouts/Flex'
import FlexColumn from '../../../../shared/components/layouts/FlexColumn'
import ServiceStatusIndicator from '../../../../shared/components/ServiceStatusIndicator'
import ServiceDomainsChips from '../../../../shared/components/ServiceDomainsChips'

function DashboardIngressList() {
  const { team } = useTeam()
  const { services } = useServices()
  const { projectsById } = useProjects()
  const { ingressesByServiceId } = useIngresses()
  const { activeTaskByServiceId } = useNodeTasks()

  const servicesWithIngress = filter(services, (service) => {
    const ingresses = get(ingressesByServiceId, service.id, [])
    return !isEmpty(ingresses)
  })

  if (isEmpty(servicesWithIngress)) {
    return (
      <Typography color="text.secondary">
        <FormattedMessage id="dashboard.quickNav.empty" />
      </Typography>
    )
  }

  return (
    <FlexColumn gap={1}>
      {map(servicesWithIngress, (service) => {
        const project = get(projectsById, service.dockerProjectId)
        const pendingTask = get(activeTaskByServiceId, service.id)

        return (
          <Box
            key={service.id}
            component={RouterLink}
            to={`/teams/${team.slug}/docker/projects/${project?.slug}/services/${service.slug}`}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              py: 1.5,
              px: 2,
              borderRadius: 1,
              textDecoration: 'none',
              color: 'inherit',
              bgcolor: 'grey.900',
              '&:hover': {
                bgcolor: 'grey.800',
                textDecoration: 'none',
              },
            }}
          >
            <Box sx={{ width: 32 }}>
              <ServiceStatusIndicator service={service} pendingTask={pendingTask} />
            </Box>
            <FlexColumn sx={{ flexGrow: 1, minWidth: 0 }} gap={0.5}>
              <Typography variant="body1" sx={{ fontFamily: 'monospace' }}>
                {project?.name} / {service.name}
              </Typography>
            </FlexColumn>
            <Flex
              gap={1}
              sx={{ flexWrap: 'wrap', justifyContent: 'flex-end' }}
              onClick={(e) => e.stopPropagation()}
            >
              <ServiceDomainsChips serviceId={service.id} />
            </Flex>
          </Box>
        )
      })}
    </FlexColumn>
  )
}

export default DashboardIngressList
